import { as, parseAs, type } from "../json.ts";
JSON.parseAs = parseAs;
JSON.as = as;
JSON.type = type;
//# sourceMappingURL=json.js.map